module.exports = __webpack_public_path__ + "img/LOGO.afc546f1.png";